<template>
  <v-row class="mb-4 mb-md-8" justify="center">
    <v-col cols="12" class="pb-0 mb-2 mb-md-4">
      <h2 class="g-heading-l text-center">
        Simplified trading - set up and trade
      </h2>
    </v-col>

    <v-col cols="12" sm="6" md="4" lg="3" class="d-flex">
      <v-card class="p-step-card flex-grow-1">
        <div class="p-step-images">
          <v-img
            contain
            class="p-step-image"
            :src="require('@/assets/flewid-logo-web.png')"
          />
          <v-icon class="p-step-number-0"> mdi-numeric-1-box </v-icon>
        </div>

        <div class="p-step-text">
          <span class="p-step-title g-bold">
            Register as a Supplier at flewidtech.com
          </span>
          <ul>
            <li>Login & Security</li>
            <li>Business Details</li>
            <li>Billing Address</li>
            <li>Licenses</li>
          </ul>
        </div>
      </v-card>
    </v-col>

    <v-col cols="12" sm="6" md="4" lg="3" class="d-flex">
      <v-card class="p-step-card flex-grow-1">
        <div class="p-step-images">
          <v-img
            contain
            class="p-step-image"
            :src="require('@/assets/flewid-user-web.png')"
          />
          <v-icon class="p-step-number-0"> mdi-numeric-2-box </v-icon>
        </div>

        <div class="p-step-text">
          <span class="p-step-title g-bold">
            Login & complete <strong>Mandatory</strong> steps to start trading
          </span>
          <ul>
            <li>Review the User Guide</li>
            <li>Bank Details for Payouts</li>
            <li v-if="featureSubscriptionEnabled">Select Subscription Tier</li>
            <li>Trading Rules - MOV, MOQ</li>
            <li>Product info, images, prices, ranging & GO LIVE date</li>
          </ul>
        </div>
      </v-card>
    </v-col>

    <v-col cols="12" sm="6" md="4" lg="3" class="d-flex">
      <v-card class="p-step-card flex-grow-1">
        <div class="p-step-images">
          <v-img
            contain
            class="p-step-image"
            :src="require('@/assets/flewid-shop-web.png')"
          />
          <v-icon class="p-step-number-0"> mdi-numeric-3-box </v-icon>
        </div>

        <div class="p-step-text">
          <span class="p-step-title g-bold">
            Setup <strong>Optional</strong> steps to maximise trade
          </span>
          <ul>
            <li>Rebates</li>
            <li v-if="featureCouponsEnabled">Coupons</li>
            <li>Logo & Brand images</li>
            <li>Multiple Account Users</li>
          </ul>
        </div>
      </v-card>
    </v-col>

    <v-col cols="12" sm="6" md="4" lg="3" class="d-flex">
      <v-card class="p-step-card flex-grow-1">
        <div class="p-step-images">
          <v-img
            contain
            class="p-step-image"
            :src="require('@/assets/flewid-product-range-web.png')"
          />
          <v-icon class="p-step-number-0"> mdi-numeric-4-box </v-icon>
        </div>

        <div class="p-step-text">
          <span class="p-step-title g-bold">
            Load <strong>Promotions</strong> - post product(s) GO LIVE date
          </span>
          <ul>
            <li>Family Groups</li>
            <li>Specials</li>
            <li>Price Drops</li>
            <li>Volume Buys</li>
          </ul>
        </div>
      </v-card>
    </v-col>

    <v-col cols="12" sm="6" md="4" lg="3" class="d-flex">
      <v-card class="p-step-card flex-grow-1">
        <div class="p-step-images">
          <v-img
            contain
            class="p-step-image"
            :src="require('@/assets/flewid-check-web.png')"
          />
          <v-icon class="p-step-number-0"> mdi-numeric-5-box </v-icon>
        </div>

        <div class="p-step-text">
          <span class="p-step-title g-bold">
            <strong>Ready to Trade</strong> - access all areas
          </span>
          <ul>
            <li>Purchase Orders</li>
            <li>Data Setup & Maintenance</li>
            <li>Reports</li>
            <li>My Account</li>
          </ul>
        </div>
      </v-card>
    </v-col>

    <v-col cols="12" sm="6" md="4" lg="3" class="d-flex">
      <v-card class="p-step-card flex-grow-1">
        <div class="p-step-images">
          <v-img
            contain
            class="p-step-image"
            :src="require('@/assets/flewid-promotions-web.png')"
          />
          <v-icon class="p-step-number-0"> mdi-numeric-6-box </v-icon>
        </div>

        <div class="p-step-text">
          <span class="p-step-title g-bold">
            <strong>Purchase Order(s)</strong> - complete a 3 step process
          </span>
          <ul>
            <li>New - confirm qty/weight</li>
            <li>In Transit - add estimated delivery date & tracking link</li>
            <li>Delivered - confirm delivered date & Proof of Delivery</li>
          </ul>
        </div>
      </v-card>
    </v-col>

    <v-col cols="12" sm="6" md="4" lg="3" class="d-flex">
      <v-card class="p-step-card flex-grow-1">
        <div class="p-step-images">
          <v-img
            contain
            class="p-step-image"
            :src="require('@/assets/flewid-invoice-web.png')"
          />
          <v-icon class="p-step-number-0"> mdi-numeric-7-box </v-icon>
        </div>

        <div class="p-step-text">
          <span class="p-step-title g-bold">
            <strong>Order Queries</strong> online from Retailers
          </span>
          <ul>
            <li>Issue Type, Images & Credit Amt – Approve or Reject</li>
          </ul>
          <span> <strong>Credit Returns</strong> (if applicable) </span>
          <br />
          <ul>
            <li>
              Contact Us to arrange setup
              <a
                class="i-a-link"
                href="mailto:support@flewidtech.com"
                target="_blank"
                >support@flewidtech.com
              </a>
            </li>
          </ul>
        </div>
      </v-card>
    </v-col>

    <v-col cols="12" sm="6" md="4" lg="3" class="d-flex">
      <v-card class="p-step-card flex-grow-1">
        <div class="p-step-images">
          <v-img
            contain
            class="p-step-image"
            :src="require('@/assets/flewid-settlement-web.png')"
          />
          <v-icon class="p-step-number-0"> mdi-numeric-8-box </v-icon>
        </div>

        <div class="p-step-text">
          <span class="p-step-title g-bold">
            <strong>Payout of Retailer Order</strong>
          </span>
          <ul>
            <li>Paid to your nominated bank accounts</li>
            <li>Includes Supplier approved Order Queries & Credit Returns</li>
          </ul>
        </div>
      </v-card>
    </v-col>

    <v-col cols="12" sm="6" md="4" lg="3" class="d-flex">
      <v-card class="p-step-card flex-grow-1">
        <div class="p-step-images">
          <v-img
            contain
            class="p-step-image"
            :src="require('@/assets/flewid-data-management-web.png')"
          />
          <v-icon class="p-step-number-0"> mdi-numeric-9-box </v-icon>
        </div>

        <div class="p-step-text">
          <span class="p-step-title g-bold">
            <strong>Reports</strong>
          </span>
          <ul>
            <li>Sales Reports</li>
            <li>Purchase Order History</li>
            <li>Payment Receipt History</li>
            <li>Order Queries History</li>
            <li>Credit Returns (if req)</li>
          </ul>
        </div>
      </v-card>
    </v-col>

    <v-col cols="12" sm="6" md="4" lg="3" class="d-flex">
      <v-card class="p-step-card flex-grow-1">
        <div class="p-step-images">
          <v-img
            contain
            class="p-step-image"
            :src="require('@/assets/flewid-user-web.png')"
          />
          <v-icon class="p-step-number-0"> mdi-numeric-1-box </v-icon>
          <v-icon class="p-step-number-1"> mdi-numeric-0-box </v-icon>
        </div>

        <div class="p-step-text">
          <span class="p-step-title g-bold">
            <strong>My Account</strong>
          </span>
          <ul>
            <li>Account Details</li>
            <li>Login & Security</li>
            <li>Multiple Users</li>
            <li>Bank Account</li>
            <li>Approved Agents</li>
          </ul>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('tenant', [
      'featureSubscriptionEnabled',
      'featureCouponsEnabled'
    ])
  }
}
</script>

<style lang="scss" scoped>
.p-step-card {
  padding: 0px 16px 16px 16px;
}
.p-step-images {
  border-radius: 5px;
}
.p-step-image {
  margin: auto;
  height: 128px;
  width: 128px;
  margin-bottom: 8px;
}
.p-step-number-0,
.p-step-number-1 {
  color: $secondary-color;
  font-size: 40px;
  position: absolute;
}
.p-step-number-0 {
  left: 10px;
  top: 10px;
}
.p-step-number-1 {
  left: 45px;
  top: 10px;
}
.p-step-text {
  padding-left: 8px;
  padding-right: 8px;

  ul {
    margin-bottom: 0px;
  }
}

@media only screen and (min-width: 960px) {
  .p-step-image {
    height: 140px;
    width: 200px;
    margin-bottom: 0px;
  }
}
</style>
